import { Badge } from './styles';

const NotificationsBadge = ({ count }) => (count ? <Badge variant="caption">{count > 99 ? '' : count}</Badge> : null);

export default NotificationsBadge;
